import { useEffect, useState } from 'react';

import '@desp-aas/desp-ui-fwk';
import "@fontsource/roboto";
import '@fortawesome/fontawesome-free/css/all.css';
import './theme/app.css';

import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';

import { appInit, GDPRBanner, LoadingPage, NavigationMobileMenu, settings, useAnalytics, useUser } from "@desp-aas/desp-ui-fwk";
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import AssetPage from './pages/AssetPage/AssetPage';
import { CatalogPage } from './pages/CatalogPage/CatalogPage';
import { DocumentationPage } from './pages/DocumentationPage/DocumentationPage';
import FormPage from './pages/FormPage/FormPage';
import NewGroupPage from './pages/NewGroupPage/NewGroupPage';
import { PostsPage } from './pages/PostsPage/PostsPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage/PrivacyPolicyPage';
import { PrivacySettingsPage } from './pages/PrivacySettingsPage/PrivacySettingsPage';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import UserPage from './pages/UserPage/UserPage';
import { ReduxState } from './redux';
import { ASSET_IMAGE_ASPECT_RATIO } from './utils/config';
import { GDPR_CONSENT_CONFIG } from './utils/gdpr';
import { helpRoutes, routes } from './utils/routes';


export default function App() {

    const dispatch = useDispatch()

    const [initialized, setInitialized] = useState(false);
    const {authChecked} = useSelector((state: ReduxState)=> state.auth );

    appInit(dispatch, { websocketOptions: { disabled: false } });


    useEffect(() => {
        if(authChecked){
            setInitialized(true);
        }
    }, [authChecked])

    // Add config variable css variables
    useEffect(() => {
        document.documentElement.style.setProperty('--asset-image-aspect-ratio', ASSET_IMAGE_ASPECT_RATIO);
    }, [])

    // const socket_id = useSelector((state: ReduxState)=> state.websocket.socket_id );

    // --- Loading screen orchestration ---------------------------------------
    // Minimum on-screen time so the loader always plays its entrance, then a
    // fade-out transition into the content. Set PIN_LOADING=true to keep the
    // loader up for design preview.
    const PIN_LOADING = false;
    const MIN_LOADING_MS = 2500;
    const EXIT_MS = 600;

    const [minTimePassed, setMinTimePassed] = useState(false);
    useEffect(() => {
        const t = setTimeout(() => setMinTimePassed(true), MIN_LOADING_MS);
        return () => clearTimeout(t);
    }, [])

    const ready = !PIN_LOADING && initialized && minTimePassed;

    // keep the loader mounted through its exit transition before unmounting it
    const [loaderVisible, setLoaderVisible] = useState(true);
    useEffect(() => {
        if (!ready) return;
        const t = setTimeout(() => setLoaderVisible(false), EXIT_MS);
        return () => clearTimeout(t);
    }, [ready])

    return (
        <div
            id="app"
        >
            <ToastContainer
                position='bottom-right'
            />
            {
                // content mounts once ready, behind the fading loader (crossfade)
                (ready || !loaderVisible) &&
                    <BrowserRouter>
                        <AppRouters />
                    </BrowserRouter>
            }
            {
                loaderVisible &&
                    <LoadingPage
                        exiting={ready}
                        title={<>Collaborative services</>}
                    />
            }
        </div>
    )
}


const AppRouters = () => {
    useAnalytics();
    const user = useUser();
    return (
        <>
            <NavigationMobileMenu
                routes={[...routes, ...helpRoutes]}
            />
            <GDPRBanner
                // updatedPolicyDate must be in ISO
                // updatedPolicyDate
                updatedPolicyDate="2026-02-05T15:49:30Z"
                // consentOptions={{
                //     "analytics": "Tracking cookies that are used to collect anonymous usage analytics of the website activity in order to improve the platform.",
                // }}
                consentConfig={GDPR_CONSENT_CONFIG}
            />
            <Routes>
                <Route path="" element={<Home />} />

                {/* <Route path="/form/:product_type" element={<FormPageOld />} /> */}
                <Route path="/form/:asset_type" element={<FormPage />} />
                <Route path="/catalog/:asset_type" element={<CatalogPage />} />
                <Route path="/profile/:user_id" element={<ProfilePage />} />

                <Route path="/asset/:asset_id" element={<AssetPage />} />
                <Route path="/course/:asset_id" element={<AssetPage />} />
                <Route path="/new-group" element={<NewGroupPage />} />
                <Route path={settings.privacySettingsPath} element={<PrivacySettingsPage />} />
                <Route path={settings.privacyPoliciesPath} element={<PrivacyPolicyPage />} />
                {/* <Route path="/groups" element={<GroupsPage />} />
                <Route path="/group/:group_id/*?" element={<GroupPage />} /> */}

                <Route path="/posts" element={<PostsPage />} />
                <Route path="/documentation/" element={<DocumentationPage />} />

                <Route path="*" element={<Navigate to=""/>} />
                {
                    user &&
                    <>
                        <Route path="/user/*" element={<UserPage />} />
                    </>
                }
            </Routes>
        </>
    )
}
